import './MetaCallback.scss';

import { useEffect, useState } from 'react';

import CompanyAPI from '../company/CompanyAPI';
import MetaAPI from './MetaAPI';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const metaAPI = new MetaAPI();
const companyAPI = new CompanyAPI();

export default function MetaCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('connecting'); // connecting, success, error

  useEffect(() => {
    async function exchangeCode() {
      const hash = window.location.hash; 
      const searchParams = new URLSearchParams(hash.split('?')[1]);
      const code = searchParams.get('code');
      
      if (!code) {
        setStatus('error');
        setTimeout(() => navigate('/marketing/conectar?erro=missing_code'), 2000);
        return;
      }
      
      try {
        const data = {
          companyId: companyAPI.getCompanyManagment().id,
          code: code,
          redirectUri: 'https://gestao.hallapp.com.br/meta/callback',
        };

        const res = await metaAPI.handleCallback(data);

        console.log("resresres", res)
        
        if (res.status !== 200) throw new Error('Falha ao trocar code por token');
        
        setStatus('success');
        setTimeout(() => navigate('/marketing/conectar?conectado=1'), 1500);
        
      } catch (e) {
        console.error('Erro ao conectar:', e);
        setStatus('error');
        setTimeout(() => navigate('/marketing/conectar?erro=oauth_exchange'), 2000);
      }
    }
    
    exchangeCode();
  }, [navigate]);

  return (
    <div className="meta-callback-container">
      <div className="meta-callback-card">
        {status === 'connecting' && (
          <>
            <div className="meta-callback-icon">
              <Spinner animation="border" variant="primary" style={{ width: '60px', height: '60px' }} />
            </div>
            <h2 className="meta-callback-title">Conectando com Meta</h2>
            <p className="meta-callback-text">
              Estamos estabelecendo a conexão com Facebook e Instagram...
            </p>
            <div className="meta-callback-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="meta-callback-icon success">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#28a745" strokeWidth="2" fill="none"/>
                <path d="M8 12l2 2 4-4" stroke="#28a745" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2 className="meta-callback-title success">Conectado com sucesso!</h2>
            <p className="meta-callback-text">
              Sua conta foi conectada. Redirecionando...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="meta-callback-icon error">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#dc3545" strokeWidth="2" fill="none"/>
                <path d="M15 9l-6 6M9 9l6 6" stroke="#dc3545" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <h2 className="meta-callback-title error">Erro na conexão</h2>
            <p className="meta-callback-text">
              Não foi possível conectar. Redirecionando...
            </p>
          </>
        )}
      </div>
    </div>
  );
}